import axios from '@/plugins/axios';
import downloadFile from '@/helpers/downloadFile';
import enumerateArray from '@/helpers/enumerateArray';

const initialState = {
  list: [],
  currentPage: 1,
  lastPage: 1,
  perPage: 20,
  balance: 0,
  payment: 0,
  deposit: 0,
  history: [],
  statistics: {
    list: {},
    total: {},
  },
};

const actions = {
  async fetchList({ commit }, params) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.get(
        `/investor_board?page=${params.page || 1}`,
        {
          headers: { Authorization: `Bearer ${token}`, Lang: lang },
          params,
        },
      );

      const list = enumerateArray(
        data.data.items.items,
        data.data.items.currentPage,
        data.data.items.perPage,
      );

      commit('setList', list);
      commit('setCurrentPage', data.data.items.currentPage);
      commit('setLastPage', data.data.items.lastPage);
      commit('setPerPage', data.data.items.perPage);
      commit('setHistory', data.data.transactions);
      commit('setCounters', {
        balance: data.data.balance,
        payment: data.data.payment,
        deposit: data.data.deposit,
      });
      return data;
    } catch (error) {
      return error;
    }
  },

  async downloadReport(_, { params, name }) {
    try {
      const lang = localStorage.getItem('language') || '';
      const token = localStorage.getItem('token') || '';
      const { data } = await axios.get('investor_board', {
        responseType: 'blob',
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
        params: {
          ...params,
          export: 1,
        },
      });

      downloadFile(data, name);

      return { success: true };
    } catch {
      return { error: true };
    }
  },

  async fetchStatistics({ commit }, params) {
    try {
      const lang = localStorage.getItem('language') || '';
      const token = localStorage.getItem('token') || '';
      const { data } = await axios.get('investor_board/statistics', {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
        params,
      });

      commit('setStatistics', data.data);
      return data;
    } catch (error) {
      return error;
    }
  },
};

const mutations = {
  setList(state, payload) {
    state.list = payload;
  },

  setCurrentPage(state, payload) {
    state.currentPage = payload;
  },

  setLastPage(state, payload) {
    state.lastPage = payload;
  },

  setPerPage(state, payload) {
    state.perPage = payload;
  },

  setHistory(state, payload) {
    state.history = payload;
  },

  setCounters(state, { balance, deposit, payment }) {
    state.balance = balance;
    state.payment = Math.abs(payment);
    state.deposit = Math.abs(deposit);
  },

  setStatistics(state, { statistics, total }) {
    state.statistics.list = statistics;
    state.statistics.total = total;
  },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
